import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { HelpCircle, ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import ConsultationPopup from './ConsultationPopup';

const FAQ = () => {
  const { t, direction } = useLanguage();

  return (
    <section id="faq" className="py-24 bg-[#0A1628] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C9A55A' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C9A55A] to-transparent opacity-60" />
      <div className="absolute top-20 right-0 w-64 h-64 bg-[#C9A55A]/5 rounded-full blur-3xl" />
      
      <div className="max-w-4xl mx-auto px-6 relative">
        
        {/* Section Header */}
        <div className={`text-center mb-16 ${direction === 'rtl' ? 'rtl' : ''}`}>
          <div className="inline-flex items-center gap-3 px-5 py-2 bg-[#C9A55A]/10 border border-[#C9A55A]/30 rounded-full mb-6">
            <HelpCircle className="w-4 h-4 text-[#C9A55A]" />
            <span className="text-sm font-semibold text-[#C9A55A] uppercase tracking-wider">
              {direction === 'rtl' ? 'الأسئلة الشائعة' : 'Frequently Asked Questions'}
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Georgia, serif' }}>
            {t.faq.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#C9A55A] to-transparent mx-auto mb-4" />
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            {t.faq.subtitle}
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {t.faq.questions.map((item, idx) => (
            <AccordionItem 
              key={idx} 
              value={`item-${idx}`}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden hover:border-[#C9A55A]/30 transition-colors"
              data-testid={`faq-item-${idx}`}
            >
              <AccordionTrigger className={`px-6 py-5 text-white hover:text-[#C9A55A] hover:no-underline ${direction === 'rtl' ? 'flex-row-reverse text-right' : ''}`}>
                <span className="text-lg font-semibold">{item.q}</span>
              </AccordionTrigger>
              <AccordionContent className={`px-6 pb-5 text-gray-300 leading-relaxed ${direction === 'rtl' ? 'text-right' : ''}`}>
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-[#C9A55A]/10 to-[#D4AF37]/10 backdrop-blur-sm border border-[#C9A55A]/30 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              {t.ui.haveMoreQuestions}
            </h3>
            <p className="text-gray-400 mb-6">
              {t.ui.contactDirectly}
            </p>
            <ConsultationPopup>
              <button
                className="px-8 py-4 bg-gradient-to-r from-[#C9A55A] to-[#D4AF37] text-[#0A1628] rounded-lg font-bold text-lg shadow-xl hover:shadow-[0_0_30px_rgba(201,165,90,0.4)] transition-all duration-300 hover:scale-105"
                data-testid="faq-cta"
              >
                {t.hero.cta}
              </button>
            </ConsultationPopup>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
